import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsCancelNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M21.414 4L20 2.586l-8 8-8-8L2.586 4l8 8-8 8L4 21.414l8-8 8 8L21.414 20l-8-8z"
        fill=""
      />
    </svg>
  )
);
SvgActionsCancelNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsCancelNormalSmall;
